// Cross-app redirect loop guard (TWISM-18949).
//
// Mirror of `host/src/shared/utils/redirect-hops.ts` — the storage key is
// shared so hops from both directions (host → legacy and legacy → host)
// count against the same budget. Keep the two files in sync.
//
// No optional chaining / nullish coalescing here: this file is built by the
// legacy Webpack 4 toolchain (see CLAUDE.md).
const STORAGE_KEY = 'twism:cross-app-redirect-hops';
export const WINDOW_MS = 30000;
export const MAX_HOPS = 3;

function readHops(): number[] {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(function (t) {
      return typeof t === 'number' && Date.now() - t < WINDOW_MS;
    });
  } catch (e) {
    return [];
  }
}

export function recordRedirectHop(): void {
  try {
    const hops = readHops();
    hops.push(Date.now());
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(hops));
  } catch (e) {
    // storage unavailable — the guard degrades to the pre-existing behavior
  }
}

export function redirectHopsExceeded(): boolean {
  return readHops().length >= MAX_HOPS;
}
